import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpHelperService } from '../services/http-helper.service';
import { ResultCardComponent } from '../components/result-card/result-card.component';
import { SkeletonLoaderComponent } from '../components/skeleton-loader/skeleton-loader.component';
import { SelectComponent } from '../components/select/select.component';
import { ProfileImageStackComponent } from '../components/profile-image-stack/profile-image-stack.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TabsComponent } from '../components/tabs/tabs.component';
import { TabComponent } from '../components/tab/tab.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SliderComponent } from '../components/slider/slider.component';
import { ConfirmationModalComponent } from '../components/confirmation-modal/confirmation-modal.component';
import { ToastErrorDetailComponent } from '../components/toast-error-detail/toast-error-detail.component';
import { TagComponent } from '../components/tag/tag.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { SelectSingleComponent } from '../components/select-single/select-single.component';
import { ProfileImageComponent } from '../components/profile-image/profile-image.component';
import { TooltipComponent } from '../components/tooltip/tooltip.component';
import { TooltipDirective } from '../directives/tooltip.directive';
import { MultiSelectComponent } from '../components/multi-select/multi-select.component';
import { ContextMenuComponent } from '../components/context-menu/context-menu.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TemplateThemeColorComponent } from '../components/template-theme-color/template-theme-color.component';
import { GetObjectKeysPipe } from '../pipes/get-oject-keys.pipe.pipe';
import { FormatColumnNamePipe } from '../pipes/format-column-name.pipe';
import { ContentModalComponent } from '../components/content-modal/content-modal.component';
import { TruncateLinesDirective } from '../directives/truncate.directive';
import { ToggleSwitchComponent } from '../components/toggle-switch/toggle-switch.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ColorPickerComponent } from '../components/color-picker/color-picker.component';
import { SizeSliderComponent } from '../components/size-slider/size-slider.component';
import { DynamicFormComponent } from '../components/dynamic-form/dynamic-form.component';
import { IconsDropdownComponent } from '../components/icons-dropdown/icons-dropdown.component';
import { OrderByPipe } from '../pipes/order-by.pipe';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { ShortDatePipe } from '../pipes/short-date.pipe';
import { TimeAgoPipe } from '../pipes/time-ago.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { DynamicTableComponent } from '../components/dynamic-table/dynamic-table.component';
import { IframeViewerComponent } from '../components/iframe-viewer/iframe-viewer.component';
import { IframeDialogComponent } from '../components/iframe-dialog/iframe-dialog.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { RolePipe } from '../pipes/role.pipe';
import { LucideIconsModule } from './lucide-icons.module';
import { DecodeHtmlPipe } from '../pipes/decode-html.pipe';
import { BadgeComponent } from '../components/badge/badge.component';
import { LoadingModalComponent } from '../components/loading-modal/loading-modal.component';
import { UtcTimePipe } from '../pipes/utc-time.pipe';
import { UtcDatePipe } from '../pipes/utc-date.pipe';
import { HighlightPipe } from '../pipes/higlight.pipe';
import { NumberFormatDirective } from '../directives/number-format.directive';
import { MultiSelectChipComponent } from '../components/multi-select-chip/multi-select-chip.component';
import { JsonEditorComponent } from '../components/json-editor/json-editor.component';
import { JsonBuilderComponent } from '../components/json-builder/json-builder.component';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import { IconSelectComponent } from '../components/icon-select/icon-select.component';
import { HighlightDirective } from '../directives/highlight.directive';

const maskConfig: Partial<any> = {
  validation: false,
};

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    ScrollingModule,
    ColorPickerModule,
    MatAutocompleteModule,
    NgScrollbarModule,
    PowerBIEmbedModule,
    LucideIconsModule,
    NgxMaskDirective,
    NgxMaskPipe,

  ],
  exports: [
    RouterModule,
    CommonModule,
    PowerBIEmbedModule,
    FormsModule,
    LucideIconsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    ResultCardComponent,
    SkeletonLoaderComponent,
    SelectComponent,
    ProfileImageStackComponent,
    TabsComponent,
    TabComponent,
    ScrollingModule,
    SliderComponent,
    TagComponent,
    SelectSingleComponent,
    ProfileImageComponent,
    TooltipComponent,
    TooltipDirective,
    MultiSelectComponent,
    ContextMenuComponent,
    MatAutocompleteModule,
    MatDialogModule,
    TemplateThemeColorComponent,
    GetObjectKeysPipe,
    FormatColumnNamePipe,
    ContentModalComponent,
    TruncateLinesDirective,
    ToggleSwitchComponent,
    NgScrollbarModule,
    ColorPickerComponent,
    SizeSliderComponent,
    DynamicFormComponent,
    OrderByPipe,
    SafeHtmlPipe,
    ShortDatePipe,
    TimeAgoPipe,
    TruncatePipe,
    IconsDropdownComponent,
    DynamicTableComponent,
    IframeViewerComponent,
    IframeDialogComponent,
    RolePipe,
    BadgeComponent,
    DecodeHtmlPipe,
    LoadingModalComponent,
    UtcTimePipe,
    UtcDatePipe,
    HighlightPipe,
    NumberFormatDirective,
    MultiSelectChipComponent,
    JsonEditorComponent,
    JsonBuilderComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    IconSelectComponent,
    HighlightDirective,
  ],
  declarations: [
    ResultCardComponent,
    SkeletonLoaderComponent,
    SelectComponent,
    ProfileImageStackComponent,
    TabsComponent,
    TabComponent,
    SliderComponent,
    ConfirmationModalComponent,
    ToastErrorDetailComponent,
    TagComponent,
    SelectSingleComponent,
    ProfileImageComponent,
    TooltipComponent,
    TooltipDirective,
    MultiSelectComponent,
    ContextMenuComponent,
    TemplateThemeColorComponent,
    GetObjectKeysPipe,
    FormatColumnNamePipe,
    ContentModalComponent,
    TruncateLinesDirective,
    ToggleSwitchComponent,
    ColorPickerComponent,
    SizeSliderComponent,
    DynamicFormComponent,
    IconsDropdownComponent,
    OrderByPipe,
    SafeHtmlPipe,
    ShortDatePipe,
    TimeAgoPipe,
    TruncatePipe,
    RolePipe,
    DynamicTableComponent,
    IframeViewerComponent,
    IframeDialogComponent,
    DecodeHtmlPipe,
    BadgeComponent,
    LoadingModalComponent,
    UtcTimePipe,
    UtcDatePipe,
    HighlightPipe,
    NumberFormatDirective,
    MultiSelectChipComponent,
    JsonEditorComponent,
    JsonBuilderComponent,
    IconSelectComponent,
    HighlightDirective,


  ],
  providers: [HttpHelperService, provideEnvironmentNgxMask(maskConfig)],
})
export class SharedModule { }
